"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockGroupInfoBlocksProperty = exports.infoBlockGroupInfoBlocksPropertyDefinition = void 0;
exports.infoBlockGroupInfoBlocksPropertyDefinition = {
    view: { label: 'List of steps, Items to win, or general information' },
    constraints: [
        {
            name: 'properties',
            argument: ['info-block'],
        },
        {
            name: 'minLength',
            argument: 1,
        },
    ],
    type: 'container',
    multiple: true,
    name: 'info-block-group-info-blocks',
};
const isInfoBlockGroupInfoBlocksProperty = (prop) => {
    return prop.name === exports.infoBlockGroupInfoBlocksPropertyDefinition.name;
};
exports.isInfoBlockGroupInfoBlocksProperty = isInfoBlockGroupInfoBlocksProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1ncm91cC1pbmZvLWJsb2Nrcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stZ3JvdXAtaW5mby1ibG9ja3MucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwwQ0FBMEMsR0FBRztJQUN4RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUscURBQXFELEVBQUU7SUFDdEUsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxZQUFZLENBQUM7U0FDekI7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxDQUFDO1NBQ1o7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLDhCQUE4QjtDQUNMLENBQUE7QUFJMUIsTUFBTSxrQ0FBa0MsR0FBRyxDQUFDLElBQWtCLEVBQTRDLEVBQUU7SUFDakgsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtEQUEwQyxDQUFDLElBQUksQ0FBQTtBQUN0RSxDQUFDLENBQUE7QUFGWSxRQUFBLGtDQUFrQyxzQ0FFOUMifQ==